import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Box } from "samba-ui";
const Item = styled(Box)`
  cursor: pointer;
  &:hover {
    background-color: #f6f9ff;
  }
  pointer-events: ${p => (p.disabled ? "none" : "auto")};
  opacity: ${p => (p.disabled ? 0.5 : 1)};
`;

const ModalItem = ({ children, ...props }) => {
  return (
    <Item py={3} px={2} {...props}>
      {children}
    </Item>
  );
};

ModalItem.propTypes = {
  children: PropTypes.node
};
export default ModalItem;
